import React, { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Loading } from "src/components";
import { AuthService } from "src/services";
import { AnalizeLogo, Card, Container, RedirectLabel, RedirectTitle } from "./styles";
import Logo from "../../assets/images/logo/logo-dark.svg"

const TensaiRedirectAuth = () => {
  /**
   * recuperando token da url
   */
  const { search } = useLocation();
  const { push } = useHistory();
  const params = new URLSearchParams(search);
  const token = params.get("token");

  const auth = new AuthService();

  /**
   * Effect: remove qualquer token que esteja salvo e verifica se o token é válido se sim ele guarda
   * o token no localstorage e redireciona para a ser feita a verificação de login;
   * Na pagina de rotas ja existe a lógica para login mediante token;
   */
  useEffect(() => {
    auth.removeToken();
    auth.isValidToken(token).then((response) => {
      if (response) {
        auth.setToken(token);
        push("/");
      }
    }).catch(()=>{
      push("/")
    });
  }, []);
  return (
    <Container>
      <AnalizeLogo src={Logo} />
      <Card>
        <Loading running size={55} />
        <RedirectTitle>Redirecionando o acesso</RedirectTitle>
        <RedirectLabel>Aguarde um instante...</RedirectLabel>
      </Card>
    </Container>
  );
};

export default TensaiRedirectAuth;
